import { ProjectStopsUnscheduledDtoModelType } from '../../models';
import getAppRoot from '../../utils/getAppRoot';

const projectStopsUnscheduledHandler = ({ store, visitIds }: ProjectStopsUnscheduledDtoModelType) => {
  const rootStore = getAppRoot(store);
  const projectId = rootStore.ui.selectedWorkspace?.id;

  if (projectId && visitIds?.length) {
    /* re-query unscheduled visits to get updated visit info
    // TODO: remove need for re-query all by adding findVisits (by id, multiple)
    //       or returning visit objects (not just ids) in subscription event payload
    */
    rootStore.model.fetchUnscheduledVisitsLatLngs(projectId);
  }
};

export default projectStopsUnscheduledHandler;
